import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";

const divRoot: HTMLDivElement = document.querySelector("#ko-set-password");
const divModel: HTMLDivElement = document.querySelector("#divUserSetPasswordModel");

export class ViewModel {
    token: string;

    busy = ko.observable(false);
    password = ko.observable<string>();
    confirm = ko.observable<string>();

    submit: () => void

    constructor(model: any) {
        let self = this;

        var data = JSON.parse(model);

        self.token = data.token;

        self.busy.subscribe(newVal => App.busy(newVal));

        self.submit = () => {
            if (!self.busy() && self.validate())
                self.save();
        }
    }

    private save() {
        let self = this;

        self.busy(true);

        var data = {
            password: self.password(),
            token: self.token
        }

        Api.SetPassword(data)
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }

    private validate(): boolean {
        let self = this;

        if (!App.validatePassword(self.password())) { App.alertWarning("Invalid Password"); return false; }
        if (self.password() !== self.confirm()) { App.alertWarning("Passwords are different"); return false; }

        return true;
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());